export const addScript = (url: string) => {
  const script = document.createElement("script");
  script.setAttribute("src", url);
  script.setAttribute("defer", "");
  script.setAttribute("async", "");
  document.body.appendChild(script);
};
